"use client";

export const WhatsAppFloat = ({ whatssAppConfig = {} }) => {
    const {
        enabled = true,
        phoneNumber = "+918097155300",
        message = "Hello! I'm interested in your services.",
        position = "bottom-right",
        tooltip = "Chat With Us",
    } = whatssAppConfig || {};

    if (!enabled) return null;

    const href = `https://wa.me/${phoneNumber.replace(/\D/g, "")}?text=${encodeURIComponent(
        message
    )}`;

    const style = {
        position: "fixed",
        zIndex: 1000,
        bottom: 20,
        right: position === "bottom-right" ? 20 : undefined,
        left: position === "bottom-left" ? 20 : undefined,
    };

    return (
        <a href={href} target="_blank" rel="noopener noreferrer" style={style} aria-label={tooltip}>
            <svg width={56} height={56} viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                <circle cx="28" cy="28" r="28" fill="#25D366" />
                <path
                    d="M37.9 18.1C35.5 15.7 32.4 14.4 29.1 14.4C22.2 14.4 16.6 19.9 16.6 26.8C16.6 28.8 17.1 30.7 18 32.4L16 40L23.8 38C25.4 38.9 27.2 39.4 29.1 39.4C36 39.4 41.6 33.9 41.6 27C41.6 23.7 40.3 20.6 37.9 18.1ZM29.1 36.9C27.5 36.9 26 36.5 24.6 35.8L24.2 35.6L20.1 36.8L21.3 32.8L21.1 32.4C20.3 30.9 19.8 28.9 19.8 26.8C19.8 21.7 24 17.5 29.1 17.5C31.4 17.5 33.6 18.4 35.2 20C36.8 21.6 37.7 23.8 37.7 26.1C37.7 31.2 33.5 35.4 28.4 35.4H28.3C28.3 35.4 28.3 35.4 28.2 35.4C28.2 35.4 28.2 35.4 28.1 35.4C28.1 35.4 28.1 35.4 28 35.4C28 35.4 28 35.4 27.9 35.4C27.1 35.4 26.4 35.2 25.7 34.9L25.7 34.9C25.5 34.8 25.3 34.7 25.1 34.6C24.9 34.4 24.8 34.3 24.6 34.2C24.6 34.2 24.6 34.2 24.6 34.2C24.6 34.2 24.6 34.2 24.5 34.2C24.5 34.2 24.5 34.2 24.5 34.2C24.5 34.2 24.5 34.2 24.4 34.1L24.4 34.1C22.9 33.3 21.7 32.1 20.9 30.6C20.9 30.6 20.9 30.6 20.9 30.6C20.8 30.5 20.8 30.4 20.7 30.3C20.6 30.1 20.5 29.9 20.4 29.7C20.3 29.4 20.2 29.1 20.2 28.8C20.2 28.3 20.4 27.8 20.8 27.4C21.2 27 21.7 26.8 22.2 26.8C22.6 26.8 23 27 23.3 27.3C23.5 27.5 23.7 27.8 23.9 28C24.1 28.2 24.3 28.5 24.5 28.7C24.5 28.7 24.5 28.7 24.5 28.7C24.6 28.8 24.7 28.9 24.8 29C25.3 29.5 25.8 29.9 26.3 30.2C26.7 30.5 27.2 30.7 27.8 30.7C28.2 30.7 28.7 30.6 29 30.3C29.4 29 29.9 28.2 30.4 27.7C30.9 27.3 31.4 27.4 31.8 27.9C32.1 28.4 32.3 29 32.3 29.6C32.3 30.6 31.9 31.4 31.3 32C30.7 32.5 29.9 32.8 29.1 32.8Z"
                    fill="#fff"
                />
            </svg>
        </a>
    );
};

